import {Divider, IconButton, Stack} from "@mui/joy";
import {FullLogoSmall} from "../Logo";
import {MenuIcon} from "lucide-react";
import {useSideNavigation} from "../../hooks/useSideNavigation";
import {Link} from "react-router-dom";

/**
 * Height the bar is pinned to.
 *
 * It floats above the page rather than sitting in it, so it leaves no room of its own and the
 * layout has to offset the content by exactly as much. A bar left to grow with whatever it holds
 * cannot be offset for, which is what used to hide the top of every screen on a phone.
 */
export const NAVBAR_HEIGHT = 64

const Navbar = () => {
    const sideNavigation = useSideNavigation()

    return <Stack display={{md: "none"}}
                  sx={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: NAVBAR_HEIGHT,
                      boxSizing: "border-box",
                      backgroundColor: "#050e1c",
                      zIndex: 2
                  }}>

        <Stack flex={1} minHeight={0} direction={"row"} alignItems={"center"}
               justifyContent={"space-between"} paddingX={2}>

            <Link to={"/"} style={{display: "flex"}} aria-label={"Score Vision"}>
                <FullLogoSmall/>
            </Link>

            <IconButton onClick={() => sideNavigation.setDrawerOpen(!sideNavigation.drawerOpen)}
                        sx={{backgroundColor: "transparent"}}>
                <MenuIcon style={{fontSize: 30}}/>
            </IconButton>
        </Stack>

        <Divider/>
    </Stack>
}

export default Navbar
